// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"cde9734032b736fc","6758":"964a024aaae0f58c"}[chunkId] + ".css";
};